import { CountryCode } from '@carsys/enums/country-code'
import { isValidBelgiumVAT } from './isValidBelgiumVAT'
import { isValidVAT } from './isValidVAT'

interface VATValidation {
  maxLength: number
  validator: (value?: string) => string | void
}

export const useVATFieldValidation = (country: string | undefined): VATValidation => {
  switch (country) {
    case CountryCode.BE:
      return {
        maxLength: 12,
        validator: isValidBelgiumVAT
      }
  }
  return {
    maxLength: 20,
    validator: isValidVAT
  }
}
